__turbopack_context__.v({
  "composeControls": "DocCard-module__1CdnXq__composeControls",
  "docCreator": "DocCard-module__1CdnXq__docCreator",
  "docDate": "DocCard-module__1CdnXq__docDate",
  "docIcons": "DocCard-module__1CdnXq__docIcons",
  "docMetadata": "DocCard-module__1CdnXq__docMetadata",
  "docMetadataDetails": "DocCard-module__1CdnXq__docMetadataDetails",
  "docThreadLink": "DocCard-module__1CdnXq__docThreadLink",
  "docTopic": "DocCard-module__1CdnXq__docTopic",
  "docTopicImage": "DocCard-module__1CdnXq__docTopicImage",
  "docTopicTitle": "DocCard-module__1CdnXq__docTopicTitle",
  "ellipsis": "DocCard-module__1CdnXq__ellipsis",
  "flexItem": "DocCard-module__1CdnXq__flexItem",
  "gradientShift": "DocCard-module__1CdnXq__gradientShift",
  "iconButton": "DocCard-module__1CdnXq__iconButton",
  "noDecoration": "DocCard-module__1CdnXq__noDecoration",
  "processingStatus": "DocCard-module__1CdnXq__processingStatus",
  "suggestedQuestionButton": "DocCard-module__1CdnXq__suggestedQuestionButton",
  "suggestedQuestions": "DocCard-module__1CdnXq__suggestedQuestions",
  "voteControls": "DocCard-module__1CdnXq__voteControls",
});
